import axios from 'axios';
import { getApiUrl } from '@/helpers/api';

export const usePostUserActivityWaiver = () => {
  const postUserActivityWaiver = async (activityId, payload) => {
    try {
      const url = `${getApiUrl()}/user-activity-waiver/${activityId}`;
      const response = await axios.post(url, payload);
      return response.data;
    } catch (err) {
      throw Error(err.response.data.message);
    }
  };

  return postUserActivityWaiver;
};
